var map = {
	"./account.svg": "ef22",
	"./adduser.svg": "f504",
	"./admin.svg": "ced6",
	"./blogs.svg": "ea66",
	"./car.svg": "ec2f",
	"./danju.svg": "dbe6",
	"./dashboard.svg": "f782",
	"./data.svg": "5a0a",
	"./dialog.svg": "6be7",
	"./dingyue.svg": "c64f",
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./eye_open.svg": "062e",
	"./form.svg": "eb1b",
	"./gg.svg": "1cf3",
	"./gift.svg": "3d7b",
	"./houtai.svg": "0edd",
	"./init.svg": "888d",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pingzheng.svg": "dddd",
	"./pingzheng02.svg": "8316",
	"./publish.svg": "98f3",
	"./purchased.svg": "cea5",
	"./relation.svg": "f8d1",
	"./relationship.svg": "ecf4",
	"./roles.svg": "c7ea",
	"./seal.svg": "5806",
	"./set.svg": "9873",
	"./shengcheng.svg": "d983",
	"./shop.svg": "5def",
	"./subject.svg": "fab3",
	"./table.svg": "47f1",
	"./text.svg": "c5f6a",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./version.svg": "8e37",
	"./weihu.svg": "f105"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";